'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
import { getUserBearerCookie } from "@/features/user/cookies/cookie-user-bearer";
import stylesHeader from "@/layout/header/header.module.scss";
import Image from "next/image";
import cx from "classix";
import Button from "@/ui/button/button";
import { ROUTER_LINKS } from "@/shared/constants/links-constants";
import Footer from "@/layout/footer/footer";
import styles from "@/_pages/error-page/error-page.module.scss";
export default function NotFoundPage() {
  const $ = _c(31);
  const translationsActions = useTranslations("global.actions");
  const errorPageTranslations = useTranslations("page.error");
  const linksTranslations = useTranslations("global.links");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getUserBearerCookie();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const isUserLogged = !!t0;
  const scrollToTop = _temp;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <button className={stylesHeader.logo} onClick={scrollToTop}><Image src="/images/roomster-logo/logo.svg" width={38} height={38} alt="roomster logo" /></button>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== translationsActions) {
    t2 = !isUserLogged && <div className={cx(stylesHeader.login, stylesHeader.login__errorPage)}><Button href={ROUTER_LINKS.phoneAuth} element="link" variant="outlined" size="lg" fullWidth={true}>{translationsActions("login")}</Button></div>;
    $[2] = translationsActions;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <header className={stylesHeader.header}><div className={stylesHeader.main}>{t1}{t2}</div></header>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className={stylesHeader.header_margin} />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className={styles.errorPage_image}><Image src="/images/roomster-graphics/sad-girl.svg" alt="error image" fill={true} /></div>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <p className={styles.errorPage_title}>404</p>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== errorPageTranslations) {
    t7 = errorPageTranslations("not-found");
    $[9] = errorPageTranslations;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t7) {
    t8 = <p className={styles.errorPage_description}>{t7}</p>;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== linksTranslations) {
    t9 = linksTranslations("home");
    $[13] = linksTranslations;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t9) {
    t10 = <a className={styles.errorPage_button} href={ROUTER_LINKS.home}>{t9}</a>;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== linksTranslations) {
    t11 = linksTranslations("help");
    $[17] = linksTranslations;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11) {
    t12 = <a className={styles.errorPage_button} href={isUserLogged ? ROUTER_LINKS.help : ROUTER_LINKS.phoneAuth}>{t11}</a>;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t10 || $[22] !== t12) {
    t13 = <div className={styles.errorPage_actions}>{t10}{t12}</div>;
    $[21] = t10;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t13 || $[25] !== t8) {
    t14 = <main className={styles.errorPage}><div className={styles.errorPage_content}>{t5}<div className={styles.errorPage_info}>{t6}{t8}{t13}</div></div></main>;
    $[24] = t13;
    $[25] = t8;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Footer />;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t14 || $[29] !== t3) {
    t16 = <>{t3}{t4}{t14}{t15}</>;
    $[28] = t14;
    $[29] = t3;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  return t16;
}
function _temp() {
  window.scrollTo({
    behavior: "smooth",
    top: 0
  });
}